"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomTag = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("@src/components/elements");
exports.CustomTag = (0, styled_components_1.default)(elements_1.Tag) `
	display: inline-flex;
	line-height: 1.8rem;
	font-size: 0.9rem;
	align-items: center;
	margin: 0;

	.ant-tag-close-icon {
		margin-left: 0.75rem;

		& > svg {
			width: 16px;
			height: 16px;
		}
	}
`;
